import styled, { css } from 'styled-components';

import { ReactComponent as CloseIcon } from '../../../assets/images/blueTheme/X.svg';

export const BadgeContainer = styled.div(
  ({ theme: { admanColors, spacers } }) => css`
    display: inline-flex;
    align-items: center;
    font-family: InspireTWDC;
    color: ${admanColors!.gray.light.bg3[3]};
    background-color: ${admanColors!.gray.light.fg[6]};
    border: 1px solid ${admanColors!.gray.light.bg3[2]};
    border-radius: 13px;
    padding: 2px ${spacers!.spacer03};

    & + & {
      margin-left: ${spacers!.spacer02};
    }

    > svg {
      width: 12px;
      height: 12px;
      margin-right: ${spacers!.spacer01};
    }
  `
);

export const BadgeIcon = styled(CloseIcon)<{ $disabled: boolean }>`
  width: 12px;
  height: 12px;
  cursor: ${({ $disabled }): string => ($disabled ? 'inherit' : 'pointer')};
`;

export const BadgeText = styled.div`
  font-size: 12px;
  line-height: 18px;
`;

export const BadgeNumber = styled.div`
  font-size: 10px;
  line-height: 15px;
  border: 10px;
  margin: 0 3px;
  width: 14px;
  height: 14px;
  border-radius: 14px;
  text-align: center;
  background-color: ${({ theme }): string => theme.admanColors!.gray.light.bg3[2]};
`;

export const TooltipContent = styled.div`
  display: inline-block;
`;
